import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function Curriculum() {
  const modules = [{
    num: 1,
    title: 'Tu Mentalidad de Mamá CEO',
    desc: 'Rompe el miedo a la tecnología y entiende por qué tu celular es una herramienta de negocios poderosa si sabes qué botones tocar.'
  }, {
    num: 2,
    title: 'El Detector de Ideas Rentables',
    desc: 'Usa la IA para descubrir exactamente qué temas está buscando la gente y qué productos digitales están dispuestos a comprar hoy.'
  }, {
    num: 3,
    title: 'Fábrica de Productos con IA',
    desc: 'El paso a paso para que la IA escriba y estructure tu producto completo en menos de 60 minutos. Tú solo copias, pegas y supervisas.'
  }, {
    num: 4,
    title: 'Diseño Profesional Express',
    desc: 'Convierte textos simples en un producto digital premium usando plantillas gratuitas desde tu celular. Cero experiencia en diseño requerida.'
  }, {
    num: 5,
    title: 'El Sistema de Ventas Faceless',
    desc: 'Cómo usar Instagram y WhatsApp para vender sin mostrar tu cara y sin perseguir a nadie. Estrategias de contenido que atraen clientes listos para comprar.'
  }];
  return <section className="bg-white px-4 pt-[36px] pb-[36px] md:pt-[50px] md:pb-[50px]" data-id="element-52">
      <div className="max-w-4xl mx-auto" data-id="element-53">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10 md:mb-16" data-id="element-54">
          <span className="text-primary font-bold uppercase tracking-wider text-sm" data-id="element-55">
            El Sistema Paso a Paso
          </span>
          <h2 className="text-3xl md:text-5xl text-dark font-display font-extrabold tracking-headline mt-2" data-id="element-56">
            Tu Mapa Exacto de Ejecución
          </h2>
        </motion.div>

        <div className="space-y-6" data-id="element-57">
          {modules.map((mod, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1
        }} className="bg-white rounded-[20px] border border-stone-200 p-6 md:p-8 shadow-sm" data-id="element-58">
              <div className="flex flex-col md:flex-row items-start gap-6" data-id="element-59">
                <div className="flex-shrink-0 w-14 h-14 rounded-full bg-white border border-stone-200 flex items-center justify-center text-primary font-bold text-xl shadow-sm" data-id="element-60">
                  {mod.num}
                </div>
                <div data-id="element-61">
                  <h3 className="text-2xl text-dark font-display font-bold mb-3" data-id="element-62">
                    Capítulo {mod.num}: {mod.title}
                  </h3>
                  <p className="text-body leading-relaxed text-lg" data-id="element-63">
                    {mod.desc}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}